import { render } from "./PfRootModal.vue?vue&type=template&id=6fe3f408"
import script from "./PfRootModal.vue?vue&type=script&lang=js"
export * from "./PfRootModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__